import React, { useEffect, useState } from "react";
import "./index.scss";
import MainLayout from "../../../../../layout/mainLayout";
import { useNavigate, useParams } from "react-router-dom";
import { api_strapi } from "../../../../../utils/interface";
import { BackArrowIcon } from "../../../../../assets/images/svg/svg";
import BlogCard from "../blogCard";

function BlogList() {
  const [blogs, setBlogs] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const getAllBlogs = async () => {
      const response = await api_strapi.get(`/blogs/getByHome/${id}`);

      if (response && response.status === 200) {
        setBlogs(
          response?.map((blog) => ({
            blogTitle: blog?.blogTitle,
            imageUrl: blog?.blogHeadingImage.map((img) => ({
              url: img?.image?.url,
            })),
            shortDescription: blog.shortDescription,
            blogSlug: blog.blogSlug,
          }))
        );
      }
    };
    getAllBlogs();
  }, [id]);

  return (
    <>
      <MainLayout>
        <div className="home--content__blogs">
          <span className="back-arrow" onClick={() => navigate(-1)}>
            <BackArrowIcon /> Back
          </span>
          <div className="row home--content--wrapper">
            {blogs?.map((data, index) => (
              <div key={index} className="col-xl-3 col-lg-4 col-sm-6 col-12">
                <BlogCard {...data} />
              </div>
            ))}
          </div>
        </div>
      </MainLayout>
    </>
  );
}

export default BlogList;
